import React, { useState } from "react";
import axios from "axios";
import { Alert, Card, Form, Button, ProgressBar, Accordion } from "react-bootstrap";
import { CONFIG, VALIDATION } from "../utils/config";
import { generateCsvTemplate } from "../utils/helpers";
import { ResultModal } from "../components/CommonUI";
import TemplateInterface from "./TemplateInterface";

export function SingleSmsTool({ addLog, saveTransaction, notify }) {
  return (
    <div className="fade-in">
      <h4 className="fw-bold text-primary mb-3">Manual Single SMS</h4>
      <Alert variant="info" className="small mb-4 border-0 shadow-sm"><i className="bi bi-info-circle me-2"></i>This tool bypasses the Template Manager. Ensure your Template ID and Variables match exactly with DLT.</Alert>
      <TemplateInterface templateId="" onBack={() => {}} addLog={addLog} saveTransaction={saveTransaction} notify={notify} />
    </div>
  );
}

export function BulkUploadTool({ addLog, saveTransaction, notify }) {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleUpload = async () => {
    if (!file) return alert("Select File");
    const reader = new FileReader();
    reader.onload = async (e) => {
        const text = e.target.result;
        if(VALIDATION.SCIENTIFIC_NOTATION.test(text)){
            alert("Scientific Notation Detected! Please format your Excel columns as Text.");
            addLog("Validation Failed: Scientific Notation found.", "ERROR");
            return;
        }
        setLoading(true); setProgress(0); setResult(null);
        const fd = new FormData();
        fd.append("file", file);
        try {
          const res = await axios.post(`${CONFIG.API_BASE}/bulk-upload`, fd, { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress: (ev) => setProgress(Math.round((ev.loaded * 100) / ev.total)) });
          addLog("Manual Bulk Upload Success.", "SUCCESS");
          saveTransaction("Bulk (Manual)", "CSV Upload", "N/A", "Success", res.data, { filename: file.name });
          setResult({ status: "Success", data: res.data });
          notify("Bulk File Processed!");
        } catch (e) {
          addLog(e.message, "ERROR");
          saveTransaction("Bulk (Manual)", "CSV Upload", "N/A", "Error", e.message, { filename: file.name });
          setResult({ status: "Error", data: { Error: e.message } });
        } finally { setLoading(false); }
    };
    reader.readAsText(file);
  };

  return (
    <div className="fade-in">
      <h4 className="fw-bold text-primary mb-3">Manual Bulk Upload</h4>
      <Alert variant="warning" className="small border-0 shadow-sm"><strong>Requirements:</strong> CSV file must have headers <code>Target</code> and <code>Content_Template_Id</code>.</Alert>
      <div className="d-flex justify-content-end mb-3"><Button variant="outline-dark" size="sm" onClick={() => generateCsvTemplate(null, [])}><i className="bi bi-download me-2"></i>Download Sample CSV</Button></div>
      <Card className="border-0 shadow-sm p-4">
        <Form.Group className="mb-4"><Form.Label className="fw-bold small">Select CSV File</Form.Label><Form.Control type="file" accept=".csv" onChange={e => setFile(e.target.files[0])} /></Form.Group>
        {loading && (<div className="mb-3"><div className="d-flex justify-content-between small mb-1"><span className="fw-bold text-primary">Uploading...</span><span className="fw-bold text-primary">{progress}%</span></div><ProgressBar now={progress} animated striped variant={progress === 100 ? "success" : "primary"} style={{height: "10px"}} /></div>)}
        <Button variant="warning" className="w-100 fw-bold" onClick={handleUpload} disabled={loading}>{loading ? "Processing..." : "Upload & Process"}</Button>
      </Card>
      <ResultModal result={result} onClose={() => setResult(null)} />
    </div>
  );
}

export function HelpCenter() {
  return (
    <div className="fade-in">
      <h4 className="fw-bold text-primary mb-3">Help Center</h4>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. How do I fix "Invalid Input" errors in CSV?</Accordion.Header>
          <Accordion.Body>This error usually happens when Excel converts long Template IDs into Scientific Notation. To fix this: <ul><li>Open your CSV in Excel.</li><li>Select the 'Content_Template_Id' column.</li><li>Right Click -&gt; Format Cells -&gt; Select 'Text'.</li></ul></Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>2. What is the correct CSV Format?</Accordion.Header>
          <Accordion.Body>The CSV must have headers: <pre className="bg-light p-2 mt-2">Target, Content_Template_Id, var1, var2</pre></Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}